module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1086.6de2005d.png";